import { render, staticRenderFns } from "./table-button.vue?vue&type=template&id=4560d3c2&scoped=true"
import script from "./table-button.vue?vue&type=script&lang=ts"
export * from "./table-button.vue?vue&type=script&lang=ts"
import style0 from "./table-button.vue?vue&type=style&index=0&id=4560d3c2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4560d3c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4560d3c2')) {
      api.createRecord('4560d3c2', component.options)
    } else {
      api.reload('4560d3c2', component.options)
    }
    module.hot.accept("./table-button.vue?vue&type=template&id=4560d3c2&scoped=true", function () {
      api.rerender('4560d3c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/table/table-button.vue"
export default component.exports